<template>
  <div class="view-tools py-5 container text-light">
    <h4 class="mb-5 text-center">Ferramentas</h4>
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <action-dispatcher action="quiz/getQuestions">
          <button class="btn btn-dark" @click="quizDialog = true">
            <img class="img-fluid" src="../assets/images/bussola.png" />
            <h5 class="my-3">BÚSSOLA GW</h5>
            Funciona assim: você responde algumas perguntinhas rápidas e ela
            aponta qual a melhor rota GW para você!
          </button>
        </action-dispatcher>
      </div>
    </div>

    <b-modal v-model="quizDialog" hide-footer hide-header>
      <action-dispatcher action="quiz/getAnswers">
        <quiz-questions
          :questions="questions"
          :answers="answers"
          @success="quizDialog = false"
        />
      </action-dispatcher>
    </b-modal>
  </div>
</template>

<script>
import QuizQuestions from "@/components/template/QuizQuestions";
import { mapState } from "vuex";

export default {
  components: {
    QuizQuestions
  },
  data() {
    return {
      quizDialog: false
    };
  },
  computed: {
    ...mapState("quiz", ["questions", "answers"])
  }
};
</script>

<style lang="scss" scoped>
.view-tools {
  button {
    background: #1c1c1c;
    color: white;
    padding: 48px 16px;

    &:hover {
      background: #191919;
    }
  }
}
</style>
